export const UPDATE_ORDER_PLACED_REQUEST = 'UPDATE_ORDER_PLACED_REQUEST';
export const FETCH_ORDER_PLACED_REQUEST = 'FETCH_ORDER_PLACED_REQUEST';
export const FETCH_ORDER_PLACED_FAILURE = 'FETCH_ORDER_PLACED_FAILURE';
export const updatedOrderPlaced = (payload) => ({
    type: UPDATE_ORDER_PLACED_REQUEST,
    payload,
});
export const fetchOrderPlacedRequest = (payload) => ({
    type: FETCH_ORDER_PLACED_REQUEST,
    payload,
});
export const fetchOrderPlacedFailure = (payload) => ({
    type: FETCH_ORDER_PLACED_FAILURE,
    payload,
});
